/**
 * Chat widget: a floating launcher that opens a resizable chat panel with
 * streaming replies, per-message feedback voting and file uploads.
 *
 * It follows the application's theme and language toggles automatically, so the
 * only required prop is `config`, which points it at a backend:
 *
 *   import ChatWidget from '../components/shared/chat-widget';
 *
 *   <ChatWidget config={{ apiUrl: `${apiBaseUrl}/chat` }} />
 *
 * See `types.ts` for the full prop and config surface, and `transports/` for the
 * supported wire formats (`sse`, `ndjson`, `text`, `json`, `openai`) plus the
 * custom-transport escape hatch.
 */

import { ChatWidget } from './ChatWidget';

export { ChatWidget };
export default ChatWidget;

export { useChat } from './hooks/useChat';
export type { UseChatOptions, UseChatResult } from './hooks/useChat';
export { useAppTheme } from './hooks/useAppTheme';
export { defaultLabels, labelsFor, mergeLabels, labelsByLanguage } from './i18n';
export { resolveTransport } from './transports';

export type {
  Attachment,
  AttachmentMode,
  ChatConfig,
  ChatLabels,
  ChatWidgetProps,
  FeedbackPayload,
  FeedbackVote,
  Message,
  MessageStatus,
  Placement,
  Protocol,
  ResolvedChatConfig,
  Role,
  ThemeMode,
  Transport,
  TransportEvent,
  TransportRequest,
  WidgetLanguage,
} from './types';
